module.exports = "/ui/main/images/slick-next-sm.png?08b3fad63db2ef3051de9d805195cee9";